exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../node_modules/css-loader/index.js?modules&importLoaders=1!../../node_modules/postcss-loader/index.js!../style/color.css"), undefined);
exports.i(require("-!../../node_modules/css-loader/index.js?modules&importLoaders=1!../../node_modules/postcss-loader/index.js!../style/breakpoints.css"), undefined);
exports.i(require("-!../../node_modules/css-loader/index.js?modules&importLoaders=1!../../node_modules/postcss-loader/index.js!../style/space.css"), undefined);

// module
exports.push([module.id, "._2Ya5bMUGQrSz2mEe4bS4lD {\n  font-weight: 500;\n  font-family: \"sofia-pro\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n  box-sizing: border-box;\n}\n\n._2Ya5bMUGQrSz2mEe4bS4lD {\n  background-color: " + require("-!../../node_modules/css-loader/index.js?modules&importLoaders=1!../../node_modules/postcss-loader/index.js!../style/color.css").locals["light"] + ";\n  display: flex;\n  height: 100%;\n  justify-content: center;\n  min-height: 100vh;\n  width: 100%;\n}\n", ""]);

// exports
exports.locals = {
	"light": "" + require("-!../../node_modules/css-loader/index.js?modules&importLoaders=1!../../node_modules/postcss-loader/index.js!../style/color.css").locals["light"] + "",
	"mediumBp": "" + require("-!../../node_modules/css-loader/index.js?modules&importLoaders=1!../../node_modules/postcss-loader/index.js!../style/breakpoints.css").locals["mediumBp"] + "",
	"smallSpace": "" + require("-!../../node_modules/css-loader/index.js?modules&importLoaders=1!../../node_modules/postcss-loader/index.js!../style/space.css").locals["small"] + "",
	"app": "_2Ya5bMUGQrSz2mEe4bS4lD"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules&importLoaders=1!./~/postcss-loader!./src/App/App.css
 ** module id = 436
 ** module chunks = 0
 **/